<template>
  <div class="merch-panel-wrapper">
    <div v-if="showedRows.length === 0" class="empty-state-container">
      <div class="empty-state-content">
        <img :src="image_base_url + 'markup/merch-no-data.svg'" alt="Empty practice product" class="empty-state-icon" />
        <p class="empty-state-title">{{ $t("OrderPage[\"You have no practice product\"]") }}</p>
        <p class="empty-state-subtitle">{{ $t("OrderPage[\"Start to manage them in ez-Bill\"]") }}</p>
        <Button colorType="sky-blue-stroke" @click="goToEzBill">{{ $t("OrderPage[\"Manage Practice Product in ez-Bill\"]") }}</Button>
      </div>
    </div>
    <div v-else class="merch-content">
      <div :class="gridContainerClass">
        <MerchCard
          v-for="(row, index) in showedRows"
          :key="row.merch?.id || index"
          :row="row"
          :is-shrink="isShrink"
        />
      </div>
    </div>
  </div>
</template>

<script>
import MerchCard from './MerchCard.vue';
import Button from "@/NewLibrary/Button.vue";
import { getRedirectUrl } from "@/utils";

import { mapState, mapGetters } from 'vuex';
import _ from "lodash";

export default {
  inject: ['image_base_url'],
  components: {
    MerchCard,
    Button,
  },
  props: {
    fixedColNumber: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      screenBreakPoints: [1008, 1254, 1500, 1746, 1992, 2238, 2484],
      innerWidth: window.innerWidth,
      isShrink: false,
    }
  },

  computed: {
    ...mapState("orderTest/order", ["paymentMethod"]),
    ...mapGetters("orderTest/merchandise", ["formattedMerchList", "selectedMerchList", "merchTotalPrice", "merchListOnEditOrder"]),

    colNumber() {
      if (this.fixedColNumber && this.fixedColNumber > 0) {
        return this.fixedColNumber;
      }
      const width =  this.innerWidth;
      if (width >= 1254 && width < 1500) {
        return 3;
      } else if (width >= 1500 && width < 1746) {
        return 4;
      } else if (width >= 1746 && width < 1992) {
        return 5;
      } else if (width >= 1992 && width < 2238) {
        return 6;
      } else if (width >= 2238 && width < 2484) {
        return 7;
      } else if (width >= 2484 ) {
        return 8;
      }
      return 2
    },
    gridContainerClass() {
      return "mx-3 grid gap-6 grid-cols-" + this.colNumber;
    },
    showedRows() {
      return this.formattedMerchList
        .filter(row => row.isShow)
    }
  },
  created() {
    this.throttledResizeHandler = _.throttle(() => {
      this.innerWidth = window.innerWidth;
      this.isShrink = window.innerWidth < 1008;
    }, 200);
    window.onresize = this.throttledResizeHandler;
  },
  methods: {
    goToEzBill() {
      const url = getRedirectUrl("markUpPage") + "/merch/manage";
      window.open(url, "_blank");
    }
  }
}
</script>

<style scoped>
.merch-panel-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.merch-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.merch-content > :first-child {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  padding: 16px;
}

.empty-state-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 500px;
  padding: 80px 0;
  width: 100%;
}

.empty-state-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.empty-state-icon {
  width: 249.298px;
  height: 166.84px;
  flex-shrink: 0;
  margin-bottom: 30px;
}

.empty-state-title {
color: #000;
text-align: center;
font-family: Roboto;
font-size: 18px;
font-style: normal;
font-weight: 500;
line-height: 20px; /* 111.111% */
}

.empty-state-subtitle {
color: #979797;
text-align: center;
font-family: Roboto;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px; /* 125% */
margin-top: 8px;
margin-bottom: 24px;
}
</style>